const func = require('../_util.js')
const page = 1
const pageSize = 10

const data = (() => {
  const result = []
  for (let index = 0; index < 60; index++) {
    result.push({
      'amount|100-99999': 1001,
      statusTxt: '@cword()',
      rateAmount: '@cword()',
      withdrawSn: '@cword()',
      'status|1-4': 1,
      goodsSupplier: '@cword()',
      applyTime: '@datetime',
      'status|1': [1, 2]
    })
  }
  return result
})()

const list = {
  url: '/record/list',
  type: 'post',
  response: func.resultPageSuccess(page, pageSize, data)
}

const info = {
  url: '/record/info',
  type: 'post',
  response: func.resultSuccess(data.find(item => item.id === 1))
}

module.exports = [list, info]
